import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';

import CheckInCheckOutDisplay from './CheckInCheckOutDisplay';
import TimeIcon from './TimeIcon';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './CheckInCheckOut.module.scss';

import { useHotelCheckinCheckoutTimes } from '@hotels-hotel-detail/data-access/hooks/useHotelContent';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
};

const CheckInCheckOut = ({ i18n: { translate } }: Props) => {
  const { checkin, checkout } = useHotelCheckinCheckoutTimes();
  const checkInTime = checkin?.time;
  const checkOutTime = checkout?.time;
  if (!checkInTime && !checkOutTime) {
    return null;
  }

  return (
    <div className={STYLES.CheckInCheckOut}>
      <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
        {(isActive: boolean) => (
          <div className={STYLES.CheckInCheckOut__sectionHeader}>
            <BpkSectionHeader
              title={
                isActive
                  ? translate('Sidebar_goodToKnow')
                  : translate('CheckInCheckOut_label_title')
              }
            />
          </div>
        )}
      </BpkBreakpoint>

      <div className={STYLES.CheckInCheckOut__main}>
        <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
          {(isActive: boolean) => (!isActive ? <TimeIcon /> : null)}
        </BpkBreakpoint>

        {checkInTime && (
          <CheckInCheckOutDisplay
            stayDes={checkin.title}
            checkInCheckOutTime={checkInTime}
          />
        )}
        {checkOutTime && (
          <CheckInCheckOutDisplay
            stayDes={checkout.title}
            checkInCheckOutTime={checkOutTime}
          />
        )}
      </div>
    </div>
  );
};

export default withI18n(CheckInCheckOut);
